import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import { useAuth } from '../../Contexts/AuthContext';
import { Templates_Get_All, Templates_Initialize, Templates_Update } from '../../api/API_Templates'
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Divider from '../ERUMAUI/UI_Divider';
import Icon_Add from '../../Assets/Icons/Icon_Add.png'
import Icon_Delete from '../../Assets/Icons/Icon_Delete.png'
import { useTemplating } from '../../Contexts/Context_Templating';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Toggle from '../ERUMAUI/UI_Toggle';
import UI_Card from '../ERUMAUI/UI_Card';
import Icon_Calendar from '../../Assets/Icons/Icon_Calendar.png';
import Icon_Table from '../../Assets/Icons/Icon_Table.png';
import Icon_Room from '../../Assets/Icons/Icon_Room.png';
import Icon_Map from '../../Assets/Icons/Icon_Map.png';
import Icon_ReservationSlip from '../../Assets/Icons/Icon_ReservationSlip.png';
import Icon_User from '../../Assets/Icons/Icon_User.png';
import Icon_Reports from '../../Assets/Icons/Icon_Reports.png';



export default function Panel_Reporter_Left() {
    const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);

    if (Loading) {
        return null;
    }
    return (
        <>
            <h2 className='General_Title'>
                Content parameters
            </h2>
        </>
    );
}
